const taskgraphLogsRouterPaths = {
  root: '/taskgraphlogs',
  details: '/taskgraphlogs/:namespace/:taskGraphId',
};

export default taskgraphLogsRouterPaths;
